import cn from 'classnames';
import messageRead from '@packages/shared/assets/chat/message-read.svg';
import { formatDate } from '@packages/shared/core/common/utils/date';
import Image from '@packages/shared/core/common/components/common/Image';
import { todayInMilliseconds } from '@packages/shared/core/common/utils';
import styles from './ChatMessage.module.scss';

type ChatMessageProps = {
  className?: string;
  text: string;
  isOutgoing?: boolean;
  isIncoming?: boolean;
};

const ChatMessage = (props: ChatMessageProps) => {
  const { text, className = '', isIncoming, isOutgoing } = props;

  const containerClasses = cn({
    [styles.wrapper]: true,
    [styles.incoming]: isIncoming,
    [styles.outgoing]: isOutgoing,
    [className]: !!className,
  });

  const timestamp = formatDate(todayInMilliseconds(), 'MM/DD h:mm A');

  return (
    <div className={containerClasses}>
      <p className={styles.messageText}>{text}</p>

      <div className={styles.timestampWrapper}>
        <span className={styles.timestamp}>{timestamp}</span>

        {isOutgoing && (
          <Image type="future" src={messageRead} width={16} height={16} className={styles.status} alt="message read" />
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
